import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { PortalUser, PortalAuthTokens } from '@/types'

interface PortalAuthState {
  user: PortalUser | null
  accessToken: string | null
  refreshToken: string | null
  isAuthenticated: boolean

  setUser: (user: PortalUser) => void
  setTokens: (accessToken: string, refreshToken: string) => void
  login: (tokens: PortalAuthTokens & { user: PortalUser }) => void
  logout: () => void
  updateUser: (updates: Partial<PortalUser>) => void
}

export const usePortalAuthStore = create<PortalAuthState>()(
  persist(
    (set) => ({
      user: null,
      accessToken: null,
      refreshToken: null,
      isAuthenticated: false,

      setUser: (user) => set({ user }),

      setTokens: (accessToken, refreshToken) =>
        set({ accessToken, refreshToken }),

      login: ({ access_token, refresh_token, user }) =>
        set({
          user,
          accessToken: access_token,
          refreshToken: refresh_token,
          isAuthenticated: true,
        }),

      logout: () =>
        set({
          user: null,
          accessToken: null,
          refreshToken: null,
          isAuthenticated: false,
        }),

      updateUser: (updates) =>
        set((state) => ({
          user: state.user ? { ...state.user, ...updates } : null,
        })),
    }),
    {
      name: 'hms-portal-auth-storage',
      partialize: (state) => ({
        user: state.user,
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
)
